export class DocumentRegistrationResult {
  constructor(public isRegistered: boolean, public detail: IDocumentRegistrationResultDetail) {
  }
}

export interface IDocumentRegistrationResultDetail {
}

export interface IDocumentRegistrationResultRegisteredDetail extends IDocumentRegistrationResultDetail {
  id: number;
  archiveId: number;
  isFirstNormalRegister: boolean;
}

export interface IDocumentRegistrationResultAlreadyUpdatedDetail extends IDocumentRegistrationResultDetail {
  isDeleted: boolean;
  isFixed: boolean;
  isRegisterableRegisteredDocumentAsTemporary: boolean;
  edition: number;
  updated: {
    userName: string;
    terminal: string;
    dateTime: Date;
  };
}
